import React from "react";
import { Globe, Check } from "lucide-react";
import { useI18n } from "@/i18n/I18nContext";
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } from "@/components/ui/dropdown-menu";

// variant="dark": sobre la barra verde oscura (icono claro, sin caja blanca)
export default function LangSwitcher({ variant = "light" }) {
  const { lang, setLang, supported, t } = useI18n();
  const labels = { es: "Español", en: "English", ca: "Català", fr: "Français" };
  
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <button
          data-testid="lang-switcher"
          className={variant === "dark"
            ? "relative p-2 rounded-xl text-white/80 hover:text-white hover:bg-white/[0.08] transition-colors flex items-center justify-center h-10 w-10"
            : "relative p-2 rounded-xl text-slate-500 hover:text-colygon-dark hover:bg-colygon-light/30 transition-colors flex items-center justify-center h-10 w-10 border border-slate-200 bg-white/80 backdrop-blur-md shadow-sm"}
          title={t("nav.change_lang")}
        >
          <Globe className="h-5 w-5" />
          <span className="absolute -top-1 -right-1 flex h-4 w-4 items-center justify-center rounded-full bg-colygon text-[0.6875rem] font-bold text-white uppercase shadow-sm">
            {lang}
          </span>
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-36 p-2 rounded-2xl bg-white/95 backdrop-blur-xl border border-slate-200 shadow-xl z-50">
        {supported.map((code) => (
          <DropdownMenuItem
            key={code}
            onClick={() => setLang(code)}
            className={`cursor-pointer rounded-xl font-bold flex justify-between items-center px-3 py-2 ${
              lang === code ? "bg-colygon-light/40 text-colygon-dark" : "text-slate-600 hover:bg-slate-50"
            }`}
          >
            {labels[code] || code.toUpperCase()}
            {lang === code && <Check className="h-4 w-4 text-colygon" />}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
